<template>
  <div :class="['vertical-anchor-menu-'+menuData[0].type,
                anchorMenuFixed ? 'vertical-anchor-menu-fixed-'+menuData[0].type : '',
                anchorMenuBottom ? 'vertical-anchor-menu-fixed-bottom-'+menuData[0].type : '']">
    <ul>
      <li v-for="(item, index) in menuData" :key="index" @click="handleClick(item, index)">
        <div v-if="item.type === 1" :class="['type-1-title', active === item.anchor ? 'type-1-active' : '']"></div>
        <div v-if="item.type === 2" :class="['type-2-title', active === item.anchor ? 'type-2-active' : '']">
          <span v-text="item.text"></span>
        </div>
        <div v-if="item.type === 3" :class="['type-3-title', active === item.anchor ? 'type-3-active' : '']">
          <span v-text="item.title"></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "index",
  computed: {
    ...Vuex.mapGetters([
      'anchorMenuFixed',
      'anchorMenuBottom'
    ]),
  },
  props: {
    menuData: {
      anchor: '',
      icon: '',
      title: ''
    },
    active: {
      default: ''
    }
  },
  watch: {

  },
  methods: {
    handleClick(data, index) {
      if (this.$listeners['onClick']) {
        this.$emit('onClick', data, index)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .vertical-anchor-menu-1 {
    width: 30px;
    height: 482px;
    position: absolute;
    top: 288px;
    right: auto;
    bottom: auto;
    left: 8%;

    & li {
      width: 20px;
      height: 20px;
      flex(row, wrap, center, center);

      & .type-1-title {
        cursor: pointer;
        width: 10px;
        height: 10px;
      }

      & .type-1-title:before {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 5px;
      }

      & .type-1-active:before {
        background-color: #0062FF;
      }
    }
  }

  .vertical-anchor-menu-fixed-1 {
    position: fixed;
    top: 378px;
    right: auto;
    bottom: auto;
    left: 8%;
  }

  .vertical-anchor-menu-fixed-bottom-1 {
    position: absolute;
    top: auto;
    right: 495px;
    bottom: 0;
    left: 8%;
  }

  .vertical-anchor-menu-2 {
    width: 400px;
    height: 620px;
    position: absolute;
    top: 175px;
    right: auto;
    bottom: auto;
    left: 8%;

    & li {
      width: 400px;
      height: 50px;
      flex(row, wrap, center, center);

      & .type-2-title {
        cursor: pointer;
        width: 400px;
        height: 50px;
        font-size: 24px;

        & span {
          display: block;
          width: 400px;
          height: 33px;
          padding-left: 30px;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      & .type-2-title:before {
        content: '';
        position: absolute;
        width: 2px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.2);
      }

      & span:before {
        content: '';
        position: absolute;
        width: 2px;
        height: 33px;
        left: 0;
      }

      & .type-2-active {
        & span {
          color: #0062FF;
        }

        & span:before {
          content: '';
          position: absolute;
          width: 2px;
          height: 33px;
          background-color: #0062FF;
        }
      }
    }
  }

  .vertical-anchor-menu-fixed-2 {
    position: fixed;
    top: 265px;
    right: auto;
    bottom: auto;
    left: 8%;
  }

  .vertical-anchor-menu-fixed-bottom-2 {
    position: absolute;
    top: auto;
    right: 495px;
    bottom: 0;
    left: 8%;
  }

  .vertical-anchor-menu-3 {
    width: 400px;
    height: 820px;
    position: absolute;
    top: 135px;
    right: auto;
    bottom: auto;
    left: 8%;

    & li {
      width: 400px;
      height: 50px;
      flex(row, wrap, center, center);

      & .type-3-title {
        cursor: pointer;
        width: 400px;
        height: 50px;
        font-size: 24px;

        & span {
          display: block;
          width: 400px;
          height: 33px;
          padding-left: 30px;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      & .type-3-title:before {
        content: '';
        position: absolute;
        width: 2px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.2);
      }

      & span:before {
        content: '';
        position: absolute;
        width: 2px;
        height: 33px;
        left: 0;
      }

      & .type-3-active {
        & span {
          color: #0062FF;
        }

        & span:before {
          content: '';
          position: absolute;
          width: 2px;
          height: 33px;
          background-color: #0062FF;
        }
      }
    }
  }

  .vertical-anchor-menu-fixed-3 {
    position: fixed;
    top: 135px;
    right: auto;
    bottom: auto;
    left: 8%;
  }

  .vertical-anchor-menu-fixed-bottom-3 {
    position: absolute;
    top: auto;
    right: auto;
    bottom: 0;
    left: 8%;
  }
</style>
